export interface Tag {
  id?: string
  label?: LangString
  description?: LangString
  equivalence?: string[]
  type?: TagType
  permission?: Permission
  edit?: Edit
}

export type TagType =
  'CORE' |
  'WORD' |
  'COLOR' |
  'TIME' |
  'LOCATION'
export const TAG_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-tag_type',
  c: {
    CORE: {
      l: {
        ja: 'コア語彙',
        en: 'core'
      },
      d: {}
    },
    WORD: {
      l: {
        ja: 'キーワード',
        en: 'Keyword'
      },
      d: {}
    },
    COLOR: {
      l: {
        ja: '色',
        en: 'Color'
      },
      d: {}
    },
    TIME: {
      l: {
        ja: '時代',
        en: 'Time'
      },
      d: {}
    },
    LOCATION: {
      l: {
        ja: '場所',
        en: 'Location'
      },
      d: {}
    }
  }
})
